export const ColumnType = {
  numeric: 'numeric',
  string: 'string',
  date: 'date',
  jsx: 'jsx',
  boolean: 'boolean',
};

export const withSearchIndex = (rows = [], columnMap = new Map()) => {
  return rows.map((row) => {
    const searchIndex = [];
    Object.keys(row).forEach((key) => {
      if (!columnMap.has(key)) return false;

      const column = columnMap.get(key);
      switch(column.type) {
        case ColumnType.numeric: {
          try {
            const index = row[key] || '';
            searchIndex.push(index);
          } catch (e) {

          }
          break;
        }
        case ColumnType.string: {
          try {
            const index = row[key] || '';
            const indexes = index.trim().toLowerCase().split(' ');
            searchIndex.push(...indexes);
          } catch (e) {

          }
          break;
        }
        default: {
          break;
        }
      }
    });

    return {
      ...row,
      searchIndex
    };
  });
};

export const search = (rows = [], filterBy = '') => {
  const keywords = filterBy.split(' ').map((item) => {
    if (isNaN(item)) return item;
    return Number(item);
  });

  return rows.filter(({ searchIndex }) => {
    return keywords.find((keyword) => {
      const regex = new RegExp(`${keyword}`, 'g');
      return searchIndex.find((item) => {
        if (typeof(item) === 'string' || isNaN(item)) return regex.test(item);
        return item === keyword;
      });
    });
  });
};
